import {EXECUTIVE_DIRECTOR, ID_BY_RANK} from '/enum/rank.enum';
import {FETCH_COACH_RANK_PROGRESSION} from '/enum/request.enum';

import {ReportProps} from '../Report.types';

/**
 * Generates a callback to show popover record when info icon is pressed
 *
 * @param {object} params - Parameters
 * @param {function} params.showRecordPopover - A callback to show record popover
 * @param {function} params.recordsShowPopover - A callback to show popover
 * @param {function} params.recordsShowRecord - A callback to show record
 *
 * @return {function} Callback - A function to be called when item is pressed
 */

export function generateOnRecordPress({
  showRecordPopover = () => {},
  recordsShowPopover = () => {},
  recordsShowRecord = () => {},
}: ReportProps) {
  return ({id}: any) =>
    showRecordPopover([id], {
      recordsShowPopover,
      recordsShowRecord,
      recordExtras: {
        rankProgression: {
          endpoint: FETCH_COACH_RANK_PROGRESSION,
          params: [id, ID_BY_RANK[EXECUTIVE_DIRECTOR]],
        },
      },
    });
}
